import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { PageComponent } from "@app/modules/shared/components/page/page.component";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
  selector: "notice-details-dialog",
  templateUrl: "./notice-list-detail-dialog.html",
  styleUrls: ["./notice-list-detail-dialog.scss"],
  standalone: true,
  imports: [
    PageComponent,
    CommonModule
  ],
})
export class NoticeListViewDetailDialogComponent implements OnInit {
  notice: any;

  constructor(
    public dialogRef: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig
  ) {}
  ngOnInit(): void {
    if (this.dialogConfig.data?.message) {
      try {
        const parsedMessage = JSON.parse(this.dialogConfig.data.message);
        this.notice = {
          ...this.dialogConfig.data,
          parsedMessage
        };
      } catch (error) {
        console.error("Invalid notice message format", error);
        this.notice = {
          ...this.dialogConfig.data,
          parsedMessage: { type: 'text', value: this.dialogConfig.data.message }
        };
      }
    }
  }
  

  goBack(): void {
    this.dialogRef.close();
  }
}
